module.exports = __webpack_public_path__ + "static/media/map3.9af7fa78.png";